const Mock = require('mockjs')
var newsData = [
  { img: '../assets/img/81.jpg', text: '汽车大灯' },
  { img: '../assets/img/78.jpg', text: '定速巡航' },
  { img: '../assets/img/75.jpg', text: 'GPS导航系统' },
  { img: '../assets/img/74.jpg', text: '倒车视频影像' },
  { img: '../assets/img/65.jpg', text: '上坡辅助' },
  { img: '../assets/img/62.jpg', text: '日间行车灯' },
  { img: '../assets/img/59.jpg', text: '车顶行李架' },
  { img: '../assets/img/55.jpg', text: '电动天窗' },
  { img: '../assets/img/52.jpg', text: '多功能方向盘' },
  { img: '../assets/img/48.jpg', text: '后视镜加热' }
]
Mock.mock('/mocks/list', 'get', newsData)
